import type { ImageData } from "../interface/ImageData";
import { ImageFormat } from "@src/lib/render-image/interface/ImageData";
import { ImageUrlParams } from "design-system/src/Components/Image/interface/ImageData";
import { generateSushiShopImageUrl } from "../generateSushiShopImageUrl";

export type IGenerateImageUrlImage = Omit<
  ImageData,
  "breakpoints" | "format"
> & {
  format?: ImageFormat;
};

/** URL img2 utilisable hors hook (SSR / Head, utilitaires). */
export const buildSushiShopImageUrl = (params: ImageUrlParams) =>
  generateSushiShopImageUrl(params);

const useSushiShopImage = () => {
  return {
    generateImageUrl: buildSushiShopImageUrl,
  };
};

export default useSushiShopImage;
